module.exports = "/_next/static/images/happy-duotone-bdceb856a96582c7c73db51f9a5001bf.svg";